export default __webpack_public_path__ + "4fa7f475baf809e6574fcc98bda1c628.png";